import React, { ReactNode } from 'react';
import { campaignContext, useCampaignConfig } from './useCampaignConfig';

type Props = {
  children: ReactNode;
};

export function CampaignProvider(props: Props) {
  const { children } = props;
  const campaignData = useCampaignConfig();
  const { Provider } = campaignContext;
  return <Provider value={campaignData}>{children}</Provider>;
}
